import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const surveyDeleteApi = createAsyncThunk(
  "auth/survey/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.surveyAction(id, 1));
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const surveyDeleteSlice = createSlice({
  name: "survey delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(surveyDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(surveyDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(surveyDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const surveyDeleteReducer = surveyDeleteSlice.reducer;
